/** 当前页面所属身份空间，用于隔离异步请求副作用；不是服务端权限依据。 */
export function getPageSessionScope(): 'platform' | 'employee' {
  const path = window.location.hash.replace(/^#/, '').split('?')[0] ?? ''
  return path === '/admin' || path.startsWith('/admin/') ? 'platform' : 'employee'
}
